module.exports = __webpack_public_path__ + "img/m3.20ba74b5.png";